function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import { getPreset, getShimmerOptions } from '../../Theme/selectors';
import withTheme from '../../Theme/withTheme';
import Shimmer from '../index';
var ShimmerTypography = function ShimmerTypography(_ref) {
  var className = _ref.className,
    propInline = _ref.inline,
    propLineHeight = _ref.lineHeight,
    propPreset = _ref.preset,
    propRadius = _ref.radius,
    propSize = _ref.size,
    style = _ref.style,
    uiTheme = _ref.uiTheme,
    propWidth = _ref.width;
  var shimmerOptions = getShimmerOptions(uiTheme, 'typography');
  var defaultInline = shimmerOptions.inline,
    defaultLineHeight = shimmerOptions.lineHeight,
    defaultPreset = shimmerOptions.preset,
    defaultRadius = shimmerOptions.radius,
    defaultSize = shimmerOptions.size,
    defaultWidth = shimmerOptions.width;
  var presetName = propPreset || defaultPreset;
  var typePreset = getPreset(uiTheme, 'typography', presetName);
  var presetLineHeight = typePreset.lineHeight,
    presetSize = typePreset.size;
  var inline = propInline || defaultInline ? 'inline-block' : 'block';
  var lineHeight = propLineHeight || presetLineHeight || defaultLineHeight || 21;
  var size = propSize || presetSize || defaultSize || 14;
  var radius = propRadius || defaultRadius || size / 2;
  var width = propWidth || defaultWidth || '100%';
  return /*#__PURE__*/React.createElement(Shimmer, {
    className: className,
    height: size,
    radius: radius,
    width: width,
    style: _objectSpread({
      marginTop: (parseInt(lineHeight, 10) - size) / 2,
      marginBottom: (parseInt(lineHeight, 10) - size) / 2,
      display: inline
    }, style)
  });
};
ShimmerTypography.defaultProps = {
  className: null,
  inline: null,
  lineHeight: null,
  preset: null,
  radius: null,
  size: null,
  style: {},
  uiTheme: {},
  width: null
};
ShimmerTypography.displayName = 'ShimmerTypography';
export default withTheme(ShimmerTypography);